import { action, observable, makeObservable } from "mobx";
import { api } from "../lib/api";
import { IStudent } from "../models/apiDataStructures";
import { SharedStateStore } from "./SharedStateStore";


export class StudentStore extends SharedStateStore {
    studentList: IStudent[] = [];
    loadingInProgress = false;
    loaded = false;

    constructor() {
        super()
        makeObservable(this, {
            studentList: observable,
            loadStudents: action,
            createStudent: action,
            editStudent: action,
            deleteStudent: action
        })
    }

    async loadStudents() {
        if (this.loadingInProgress) return;
        this.setState({ loadingInProgress: true, loaded: false})
        try {
            let newStudents = (await api.find("profile/students"))
            this.setState({studentList: newStudents})
        } catch (err) {
            throw err;
        } finally {
            this.setState({
                loadingInProgress: false,
                loaded: true
            })
        }
    }

    async createStudent(student: IStudent) {
        try {
            await api.create(
            "profile/students",
            {...student}
        )
        } catch (err) {
            throw err
        } finally {
            this.loadStudents();
        }
    }

    async deleteStudent(id?: number): Promise<void> {
        if (!id) return
        try {
            await api.delete(`profile/student/${id}`)
        } catch (err) {
            throw err
        } finally {
            this.loadStudents();
        }
    }

    async editStudent(student: IStudent) {
        try {
            await api.put(
                `profile/student/${student.id}`,
                {...student}
            )
        } catch(err) {
            throw err
        } finally {
            this.loadStudents();
        }
    }

}